// extracted by mini-css-extract-plugin
export default {"loginText":"login-form_loginText__AuKt0","loginCard":"login-form_loginCard__+7z04"};